module.exports = __webpack_public_path__ + "img/similar-pered-sad2.b4c6cf2b.png";